import PropTypes from "prop-types";
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useTranslation } from "react-i18next";
import Card from "../../../components/Cards/Card";
import { CustomSwitch } from "../../../components/CustomControls/CustomSwitch";

export const NotificationsUsers = (props) => {
  const { t } = useTranslation();
  const { startup, notificationState, onChange } = props;

  const columns = [
    {
      dataField: "fullName",
      text: t("clinicalTrials.notifications.usersFullName"),
      formatter: (_, row) => row.practitioner?.fullName ?? "-",
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (_, row) => (
        <CustomSwitch
          name="email"
          value={notificationState?.[row.practitionerUserId]?.email || false}
          bsSize="small"
          onChange={(_, val) => onChange(row.practitionerUserId, "email", val)}
        />
      ),
    },
    {
      dataField: "sms",
      text: "SMS",
      formatter: (_, row) => (
        <CustomSwitch
          name="sms"
          value={notificationState?.[row.practitionerUserId]?.sms || false}
          bsSize="small"
          onChange={(_, val) => onChange(row.practitionerUserId, "sms", val)}
          disabled={true}
        />
      ),
    },
    {
      dataField: "whatsapp",
      text: "WhatsApp",
      formatter: (_, row) => (
        <CustomSwitch
          name="whatsapp"
          value={notificationState?.[row.practitionerUserId]?.whatsapp || false}
          bsSize="small"
          onChange={(_, val) =>
            onChange(row.practitionerUserId, "whatsapp", val)
          }
          disabled={true}
        />
      ),
    },
  ];

  return (
    <>
      <Card
        content={
          <BootstrapTable
            data={startup?.protocol?.protocolPractitioners || []}
            keyField="practitionerUserId"
            columns={columns}
            bordered={false}
            classes="table-sm table-striped"
          />
        }
      />
    </>
  );
};

NotificationsUsers.propTypes = {
  startup: PropTypes.object.isRequired,
  notificationState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
